import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6fb2680a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2680a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb2680a')) {
      api.createRecord('6fb2680a', component.options)
    } else {
      api.reload('6fb2680a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6fb2680a&scoped=true&", function () {
      api.rerender('6fb2680a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gb6AQX6ppaYw/JS/comp/Accordion.vue"
export default component.exports